<div [formGroup]="form">
  <div>
    <h3 class="nn-form-title">Natural Number</h3>
    <div>
      <mat-expansion-panel  [expanded]="checkDiffs('identified', diffs)">
        <mat-expansion-panel-header>
          @if (identifiedNN  != nnNone) {
            <mat-panel-title >
              <span class="header-name"><mat-icon>{{ nnIconIdentified }}</mat-icon></span> &nbsp; Identified
            </mat-panel-title>
          } @else {
            <span class="header-name"><mat-icon>{{ nnIconIdentified }}</mat-icon></span> &nbsp; <em class="empty-title">Not yet identified</em>
          }
        </mat-expansion-panel-header>
        @if (!(self)) {
          <span>
            <source-form formControlName="identified" ></source-form>
          </span>
        }
        @if (self) {
          <span>
            @if (value.identified.naturalNumber) {
              <span> Natural Number: {{ value.identified.naturalNumber }},
                @if (value.identified.setBy && value.identified.setBy.name) {
                  <span> By: {{ value.identified.setBy.name }},</span>
                }
                @if (value.identified.setAt) {
                  <span> At: {{ value.identified.setAt }}, </span>
                }
                @if (value.identified.dateSet) {
                  <span> On: {{ value.identified.dateSet }}</span>
                }
              </span>
            }
            <span (mouseenter)="changeText=true" (mouseleave)="changeText=false">
              @if (!changeText) {
                <span><span class="material-icons">help_outline</span></span>
              }
              @if (changeText) {
                <span> d>Please email susanandmartin&#64;bodyof9.com if this information is not correct.</span>
              }
            </span>
          </span>
        }
      </mat-expansion-panel>

      <mat-expansion-panel  [expanded]="checkDiffs('asserted', diffs)">
        <mat-expansion-panel-header>
          @if (sourceType != nnNone) {
            <mat-panel-title >
              <span class="header-name"><mat-icon>{{ nnIconAsserted }}</mat-icon></span> &nbsp; Asserted
            </mat-panel-title>
          } @else {
            <span class="header-name"><mat-icon>{{ nnIconAsserted }}</mat-icon></span> &nbsp; <em class="empty-title">No NN asserted</em>
          }
        </mat-expansion-panel-header>
        <source-form formControlName="asserted" ></source-form>
      </mat-expansion-panel>

      <mat-expansion-panel  [expanded]="checkDiffs('invited', diffs)">
        <mat-expansion-panel-header>
          @if (invitedNN  != nnNone) {
            <mat-panel-title >
              <span class="header-name"><mat-icon>group</mat-icon></span> &nbsp; Invited
            </mat-panel-title>
          } @else {
            <span class="header-name"><mat-icon>group</mat-icon></span> &nbsp; <em class="empty-title">No one yet invited</em>
          }
        </mat-expansion-panel-header>
        <source-form formControlName="invited"></source-form>
      </mat-expansion-panel>

      <mat-expansion-panel  [expanded]="checkDiffs('history', diffs)">
        <mat-expansion-panel-header>
          @if (historyList  && historyList.length > 0) {
            <mat-panel-title >
              <span class="header-name"><mat-icon>history</mat-icon></span> &nbsp; History
            </mat-panel-title>
          } @else {
            <span class="header-name"><mat-icon>history</mat-icon></span> &nbsp; <em class="empty-title">No active history</em>
          }
        </mat-expansion-panel-header>
        @if (historyList  && historyList.length > 0) {
          <div>
            <ul>
              @for (h of historyList; track h) {
                <li>NN:{{ h.naturalNumber }}, By:{{ h.setBy.name}}, At:{{h.setAt }}, SRC:{{ h.source }}, Date:{{ h.dateSet }}</li>
              }
            </ul>
          </div>
        } @else {
          No Natural Number History recorded
        }
      </mat-expansion-panel>

    </div>
  </div>
